import {
  MotifButton,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifToast,
} from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import {
  CANCEL_BUTTON_VARIANT,
  YES_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { CommonModalHeader } from "@/components/Modal/CommonModalHeader/CommonModalHeader";
import { useTrans } from "@/components/Functions/dateFunc";

export function NoClaimModel({
  showModal,
  setShowModal,
  disableCreditor,
  successPopUp,
  setSuccessPopUp,
  itemName,
  creditorDisable,
}: any) {
  const { t } = useTranslation();
  return (
    <>
      <MotifModal
        onClose={() => setShowModal(false)}
        show={showModal}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="confirmationModalWrapper creditor_disabling_model">
          <MotifModalHeader headerIcon={CommonModalHeader()}></MotifModalHeader>

          <MotifModalBody style={{ paddingTop: "0px" }}>
            <span style={{ fontWeight: "300" }}>
              {useTrans(
                t,
                t(
                  "pages.creditors.creditorDisablePopupDetails.warningMessage",
                  { creditorName: itemName }
                ),
                "creditorName"
              )}
            </span>
          </MotifModalBody>
          <MotifModalFooter>
            <MotifButton
              size="small"
              type="submit"
              variant={YES_BUTTON_VARIANT}
              style={{
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
              onClick={disableCreditor}
              loading={creditorDisable}
            >
              {t("global.globalActions.yes")}
            </MotifButton>
            <MotifButton
              className=""
              onClick={() => setShowModal(false)}
              size="small"
              type="button"
              variant={CANCEL_BUTTON_VARIANT}
            >
              {t("global.globalActions.cancel")}
            </MotifButton>
          </MotifModalFooter>
        </div>
      </MotifModal>
      {successPopUp && (
        <MotifToast
          onClose={() => setSuccessPopUp(false)}
          variant="success"
          className="mar-b-20"
        >
          {t("pages.creditors.creditorDisablePopupDetails.disabledMessage", {
            creditorName: itemName,
          })}
        </MotifToast>
      )}
    </>
  );
}

export function ActiveClaimModel({ showModal, setShowModal, itemName }: any) {
  const { t } = useTranslation();

  return (
    <MotifModal
      onClose={() => setShowModal(false)}
      show={showModal}
      focusTrapOptions={{
        tabbableOptions: {
          displayCheck: "none",
        },
      }}
    >
      <div className="confirmationModalWrapper creditor_disabling_model">
        <MotifModalHeader headerIcon={CommonModalHeader()}></MotifModalHeader>
        <MotifModalBody style={{ paddingTop: "0px" }}>
          <span style={{ fontWeight: "300" }}>
            {useTrans(
              t,
              t(
                "pages.creditors.creditorDisablePopupDetails.cannotDeletMessage",
                { creditorName: itemName }
              ),
              "creditorName"
            )}
          </span>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton
            className=""
            onClick={() => setShowModal(false)}
            size="small"
            type="button"
            variant={CANCEL_BUTTON_VARIANT}
          >
            {t("global.globalActions.cancel")}
          </MotifButton>
        </MotifModalFooter>
      </div>
    </MotifModal>
  );
}
